TS.ns('WL');

WL.leasingOfferDataModel = new Class({
    Extends: WL.documentBase,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var dealerList = me.getDomainProperty('browseDealer_Property');

        if (dealerList != null) {
            dealerList.on('selectionChanged', me.onDealerChanged, me);
        }
    },

    onDealerChanged: function (newValue) {
        var me = this;

        me.performServerCommand('ComputeMBFSResponsible', true);
    }

});